import { createAction } from '@reduxjs/toolkit';

// Tournament actions
export const cancelTournament = createAction<any>('tournaments/cancelTournament');
export const createTournament = createAction<any>('tournaments/createTournament');
export const updateBlindStructure = createAction<any>('tournaments/updateBlindStructure');
export const createBlindStructure = createAction<any>('tournaments/createBlindStructure');
